import { Component, Input, OnInit } from '@angular/core';
import { ChartItem } from "../../../../shared/donut-chart/chart-item.model";
import { NgForOf, NgIf, NgStyle } from "@angular/common";
import { PieChartModule } from "@swimlane/ngx-charts";

@Component({
  selector: 'app-platform-chart',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    PieChartModule,
    NgStyle,
  ],
  templateUrl: './platform-chart.component.html',
  styleUrl: './platform-chart.component.scss'
})
export class PlatformChartComponent implements OnInit {
  @Input('data') data: ChartItem[] = [];
  @Input('chartTitle') chartTitle: string;
  @Input('iconClass') iconClass: string;
  @Input('hasData') hasData = false;

  view: [number, number] = [250, 250];

  // options
  gradient: boolean = false;
  showLegend: boolean = false;
  showLabels: boolean = false;
  isDoughnut: boolean = true;

  customColours: any[] = [];

  ngOnInit(): void {
    if (this.data.length > 0) {
      this.customColours = [];
      this.data.forEach(item => {
        this.customColours.push({ name: item.name, value: item.colour });
      });
    }
  }
}
